import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormsService } from "../../providers/forms.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FirebaseService } from "../../providers/firebase.service";
import { ScrollService } from "../../providers/scroll.service";
import { FirebaseObjectObservable } from "angularfire2/database-deprecated";
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import { Observable } from "rxjs/Observable";
import { LeaseVariables } from "../../models/lease-variables";
import { SignaturePad } from "angular2-signaturepad/signature-pad";
import { isNull, isUndefined } from "util";
import { AWSConnectorService } from '../../providers/aws-connector';
import * as _ from 'lodash';

@Component({
  selector: 'app-forms-retrieve-setting-variables',
  templateUrl: './forms-retrieve-setting-variables.component.html',
  styleUrls: ['./forms-retrieve-setting-variables.component.scss']
})
export class FormsRetrieveSettingVariablesComponent implements OnInit, AfterViewInit {
  key: string;
  locKey: string;
  path: string;
  filterText: string;
  chargesData;
  filteredData;
  clientData: Client = new Client;
  client: FirebaseObjectObservable<Client>;
  location: FirebaseObjectObservable<LocationInfo>;

  leaseVars = new LeaseVariables();
  signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': .5,
    'canvasWidth': 600,
    'canvasHeight': 200,
    'backgroundColor': '#fdfdfd'
  };
  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  constructor(
    public forms: FormsService,
    private router: Router,
    public route: ActivatedRoute,
    public afService: FirebaseService,
    private scroll: ScrollService,
    private awsConn: AWSConnectorService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.locKey = params['locKey'];
      this.path = '/clients/' + this.key + '/locations/' + this.key + '/' + this.locKey;
      this.client = this.afService.getClientInfo(this.key);
      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;

        this.location = this.afService.getLocationInfo(this.key, this.locKey);
      });
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.afService.getLocationEsignInfo(this.key, this.locKey).subscribe((leaseVars) => {
        if (isNull(leaseVars.$value)) {
          this.leaseVars = new LeaseVariables();
          this.save(false);
        }
        else {
          this.leaseVars = leaseVars;
          if (!isUndefined(this.leaseVars.employeeSignature)) {
            this.signaturePad.fromDataURL(this.leaseVars.employeeSignature);
          }
        }
      });
    }, 500);
    this.scroll.scrollToTop();
  }

  save(saveSig = true) {
    if (saveSig == true) {
      this.leaseVars.employeeSignature = this.signaturePad.toDataURL();
    }

    this.afService.saveLocationEsignInfo(this.clientData, this.leaseVars, this.locKey).then(() => {
      this.afService.openSnackBar('Location Saved Successfully.');
    }).catch(e => {
      this.afService.openSnackBar('ERROR saving Location.');
    });
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  filter() {
    this.filteredData = _.filter(this.chargesData, c => {
      if (this.filterText) {
        return c.sChgDesc.toLowerCase().includes(this.filterText.toLocaleLowerCase());
      }
      else return true;
    });
  }

  loadChargeTypes() {
    const sub = this.awsConn.getAllChargeTypes(this.clientData.code, this.locKey).subscribe(data => {
      sub.unsubscribe();
      console.log(data)
      this.filteredData = this.chargesData = data;
    });
  }

  goBack() {
    this.router.navigate(['../../create-leases'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/forms-retrieve-setting-variables/forms-retrieve-setting-variables.component.ts